"use strict";

import Vue from "vue";
import axios from "axios";

const baseURL = process.env.NODE_ENV === 'development' ? '/api' : "//interact-client.jd.com/api"; //线上
axios.defaults.baseURL = baseURL
// axios.defaults.baseURL = "//beta-share-client.m.jd.com/api";//预发 - 上线前注释掉
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  res => {
    if (res.data.code == "604") {
      location.href =
        "//msc.jd.com/payPwd/loginpage/wcoo/toShortIndex?source=15&active=101&returnUrl=" +
        encodeURIComponent(location.href);
        return Promise.reject()
    } else if (res.data.code == "20001") {
      location.href =
        "//plogin.m.jd.com/user/login.action?appid=1029&returnurl=" +
        encodeURIComponent(location.href);
      return Promise.reject()
    } else if (res.data.code == "402020005") {
      location.pathname += "/error";
      return Promise.reject()
    } else if (res.data.code != "200") {
      // Vue.prototype.$toast(res.data.message || res.data.msg)
      return Promise.reject(res.data);
    } else {
      return res.data.data;
    }
  },
  error => {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
